import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ScheduleCancel() {
  const token = new URLSearchParams(window.location.search).get('token');
  const base = import.meta.env.VITE_APP_API_BASE_URL;
  const [info, setInfo] = useState(null);
  const [state, setState] = useState('loading'); // loading | ready | done | error | notfound
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setMessage('Missing cancellation link.'); return; }
    axios.get(`${base}/cancel`, { params: { token } })
      .then((r) => { setInfo(r.data.data); setState(r.data.data?.status === 'Cancelled' ? 'done' : 'ready'); })
      .catch((e) => { setState(e.response?.status === 404 ? 'notfound' : 'error'); setMessage('We could not find this booking.'); });
  }, [token, base]);

  const cancel = async () => {
    try {
      setState('loading');
      const r = await axios.post(`${base}/cancel`, { token });
      setMessage(r.data.message || 'Your booking has been cancelled.');
      setState('done');
    } catch {
      setState('error'); setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center font-serif text-[#241511]">
      <h1 className="text-2xl text-[#9d1f1c] mb-4">Cancel your booking</h1>
      {state === 'loading' && <p>Please wait…</p>}
      {state === 'notfound' && <p>{message}</p>}
      {state === 'error' && <p className="text-red-700">{message}</p>}
      {state === 'ready' && info && (
        <div className="space-y-4">
          <p>Hari Om {info.name}, you're booked{info.eventLocation ? ` at ${info.eventLocation}` : ''}{info.partySize ? ` for ${info.partySize} ${info.partySize > 1 ? 'people' : 'person'}` : ''}.</p>
          <p>Cancelling will release your seat{info.partySize > 1 ? 's' : ''} so others can register.</p>
          <button onClick={cancel} className="bg-[#5a0000] hover:bg-[#8a0000] text-white px-6 py-2 rounded-lg">Cancel my booking</button>
        </div>
      )}
      {state === 'done' && <p className="text-green-800">{message || 'Your booking has been cancelled. Hari Om 🙏'}</p>}
    </div>
  );
}
